import { DivShowAndHideTypes } from './div-show-and-hide.type';

const INITIAL_STATE = {

    showRblKycSection: true,
    showBiometricSection: false,
    showRblOtpVerifySection: false,

    showIciciOnboardingSection: true,
    showIciciKycSection: false,
    showIciciKycSuccessSection: false
};

const divShowAndHideReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case DivShowAndHideTypes.SHOW_RBL_KYC_SECTION:
            return {
                ...state,
                showRblKycSection: true,
                showBiometricSection: false,
                showRblOtpVerifySection: false
            };
        case DivShowAndHideTypes.SHOW_BIOMETRIC_SECTION:
            return {
                ...state,
                showRblKycSection: false,
                showBiometricSection: true,
                showRblOtpVerifySection: false
            };
        case DivShowAndHideTypes.SHOW_RBL_OTP_VERIFY_SECTION:
            return {
                ...state,
                showRblKycSection: false,
                showBiometricSection: false,
                showRblOtpVerifySection: true,
            };

        case DivShowAndHideTypes.SHOW_ICICI_ONBOARDING_SECTION:
            return {
                ...state,
                showIciciOnboardingSection: true,
                showIciciKycSection: false,
                showIciciKycSuccessSection: false
            };
        case DivShowAndHideTypes.SHOW_ICICI_KYC_SECTION:
            return {
                ...state,
                showIciciOnboardingSection: false,
                showIciciKycSection: true,
                showIciciKycSuccessSection: false
            }; 
        case DivShowAndHideTypes.SHOW_ICICI_KYC_SUCCESS_SECTION:
            return {
                ...state,
                showIciciOnboardingSection: false,
                showIciciKycSection: false,
                showIciciKycSuccessSection: true
            };
        case DivShowAndHideTypes.RESET:
            return INITIAL_STATE;
                                                           
        default:
            return state;
    }
};

export default divShowAndHideReducer; 